import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import ViewUI from 'view-design'
import {getToken, setTitle} from '@/libs/util'
import config from '@/config'

const {homeName, offlineHomeName} = config

Vue.use(Router)
const router = new Router({
  routes,
  mode: 'history'
})
const LOGIN_PAGE_NAME = 'login'

router.beforeEach((to, from, next) => {
    ViewUI.LoadingBar.start()
    const token = getToken()
    if (!token && to.name !== LOGIN_PAGE_NAME) {
      // 未登录且要跳转的页面不是登录页
      next({
        name: LOGIN_PAGE_NAME // 跳转到登录页
      })
    } else if (!token && to.name === LOGIN_PAGE_NAME) {
      // 未登陆且要跳转的页面是登录页
      next() // 跳转
    } else if (token && to.name === LOGIN_PAGE_NAME) {
      if (token == "离线模式") {
        next({
          name: offlineHomeName // 跳转到homeName页
        })
      } else {
        // 已登录且要跳转的页面是登录页
        next({
          name: homeName // 跳转到homeName页
        })
      }
    } else {
      console.log(to)
      console.log(from)
      if (to.name == "guide"&& sessionStorage.getItem("isAllow")==0 && (from.name == "home" || from.name == "waybillcreate" ||from.name == "waybillcreate2"  || from.name == "takewaybills")) {
        next(false)
      } else {
        sessionStorage.setItem("isAllow", 0);
        next()
      }
      // var info = sessionStorage.getItem("info");
      // if (to.name == "home" && from.name == "waybillcreate" && !!info) {
      //   next(false)
      // } else {
      //   next()
      // }
    }
  }
)

router.afterEach(to => {
  setTitle(to, router.app)
  ViewUI.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router
